import React from 'react';

import FooterMenu from './FooterMenu';
const Footer = () => {
    return (
        <>
            <div className='footer-main'>
                
                <footer className='footer pt-5'>
                    <FooterMenu />
                </footer>
            </div>
        </>
    )
}
export default Footer